import auth0Service from './auth0Service';

export default auth0Service;



// WEBPACK FOOTER //
// ./src/auth0Service/index.js